import { useEffect, useState } from 'react';
import { getPracticePrescriptionList } from 'api/group';
import { getProviderPrescriptionList } from 'api/textVisit';
import { EViewType, TPracticePrescriptionItem, TPracticePrescriptionListFilter } from 'types/group';
import { EPrescriptionListSortBy, EPrescriptionListStatus } from 'types/textVisit';

type Params = TPracticePrescriptionListFilter & {
    viewType?: EViewType;
};

export default function useGetGroupOrSelfPrescriptionList(
    props: Params,
): [TPracticePrescriptionItem[], number, boolean, (filter: Params) => void] {
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [listData, setListData] = useState<TPracticePrescriptionItem[]>([]);

    const fetchData = async (filter: Params) => {
        try {
            setLoading(true);
            let result;
            if (filter.viewType === EViewType.GROUP_PRACTICE) {
                result = await getPracticePrescriptionList(filter);
            } else {
                result = await getProviderPrescriptionList({
                    current: filter.current,
                    size: filter.size,
                    patientName: filter.patientName,
                    drugName: filter.drugName,
                    status: filter.status as EPrescriptionListStatus[] | undefined,
                    sortBy: filter.sortBy as EPrescriptionListSortBy | undefined,
                    sortType: filter.sortType as 'ASC' | 'DESC' | undefined,
                });
            }
            if (!result.error) {
                const data = (result?.data?.data?.list || []) as TPracticePrescriptionItem[];
                const _total: number = result?.data?.data?.totalRecords || 0;
                setTotal(_total);
                setListData(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(props);
    }, [props.providerId, props.viewType]);

    return [listData, total, loading, fetchData];
}
